const links = document.querySelectorAll('a[href^="#"]');

for (const link of links) {
    link.addEventListener('click', clickHandler);
}

function clickHandler(e) {
    e.preventDefault();

    let href = this.getAttribute('href');

    // Set default header height to 0
    var headerHeight = 0;

    // If it isn't "undefined" and it isn't "null", then it exists.
    if(typeof(document.querySelector('[data-fixed-header]')) != 'undefined' && document.querySelector('[data-fixed-header]') != null){
        var fixedHeaderElements = document.querySelectorAll('[data-fixed-header]');
        for(var i=0; i < fixedHeaderElements.length; i++){
            var fixedHeaderElement = fixedHeaderElements[i];
            headerHeight += fixedHeaderElement.offsetHeight;
        }
    }

    // Set offset
    let offsetTop = document.querySelector(href).offsetTop - headerHeight;

    // Scroll to anchor
    scroll({
        top: offsetTop,
        behavior: 'smooth'
    });

    if(g_dev === true) {
        console.log('Gescrollt naar "'+this.getAttribute('href')+'" met scroll positie "'+headerHeight+'px".');
    }


    // Update scroll position after 175ms
    setTimeout(function(){
        var headerHeight2 = 0;
        if(typeof(document.querySelector('[data-fixed-header]:not(.invisible)')) != 'undefined' && document.querySelector('[data-fixed-header]:not(.invisible)') != null){
            var fixedHeaderElements = document.querySelectorAll('[data-fixed-header]:not(.invisible)');
            for(var i=0; i < fixedHeaderElements.length; i++){
                var fixedHeaderElement = fixedHeaderElements[i];
                headerHeight2 += fixedHeaderElement.offsetHeight;
            }
        }
        offsetTop = document.querySelector(href).offsetTop - headerHeight2;

        if(headerHeight != headerHeight2) {
            scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    }, 175);
}
